import { ANONYMOUS_SHOPPER_ID_KEY } from "@redotech/redo-web/utils/shared-conf";
import { inCoverageBuilderMode } from "../coverage-builder/coverage-builder-init";
import type { RedoEmittedDomEvent } from "../dom-events";
import { PreviewModeState } from "../preview-mode/preview-state";

/** The shopper to attribute a storefront coverage event to; none in preview or builder mode. */
export function readEligibleAnonymousId(): string | undefined {
  if (PreviewModeState.isActive() || inCoverageBuilderMode()) {
    return undefined;
  }
  return localStorage.getItem(ANONYMOUS_SHOPPER_ID_KEY) || undefined;
}

export function dispatchStorefrontCoverageEvent<TDetail>(
  eventName: RedoEmittedDomEvent,
  detail: TDetail,
): void {
  window.dispatchEvent(new CustomEvent<TDetail>(eventName, { detail }));
}
